export var isTempTestPending = function isTempTestPending() {
  return localStorage.getItem("tempTest") !== null && localStorage.getItem("tempTest") !== "null";
};